module.exports = __webpack_public_path__ + "img/16.2a82e337.jpg";